import { useDataStore } from '@/stores/data.js'
import { helperFunctions } from "@/composable/helperFunctions";


const {  downloadBase64 } = helperFunctions;


export class WalletService {
  constructor() {
    this.service = 'PAYROLL'
    this.store = useDataStore()
    this.link = ''
  }
/**
 * @property({ type: Array })
   * @returns {Array}
   */
  get transactionHistory() {
    return this.store.getTransactionHistory?.transactions || []
  }
/**
  * @property({ type: Number })
   * @returns {Number}
   */
  get walletBalance() {
    return this.store.getWalletBalance?.balance || 0
  }

  /**
   * @property({ type: Object })
   * @returns {Object}
   */
  get companyAccountDetails() {
    return this.store.getCompanyAccountDetails || {}
  }

  /**
   * @returns {String}
   */
  get paystackLink() {
    return this.link
  }

  /**
   * @returns {Array}
   */
  get beneficiaryData() {
    return this.store.getBeneficiaryData?.data || []
  }

  /**
   * @property({ type: Object })
   * @returns {Object}
   */
  get companyAdmin() {
    return this.store.getCompanyAdmin || {}
  }

  /**
   * @property({ type: Object })
   * @returns {Object}
   */
  async queryCompanyAdmin(){
    try{    
      await this.store.query({
        endpoint: "FetchCompanyAdmin",
      service: "SETTINGS",
        storeKey: "companyAdmin",
      });
    } catch (e) {
      console.log(e);
    }
  };

  /**
   * @returns {Object}
   */
  async  listBeneficiaries() {
 try {
       await this.store.query({
        endpoint: "ListBeneficiaries",
  
        service: this.service,
        storeKey: "beneficiaryData",
      });
    } catch (err) {
      console.log(err);
    }
  }

  /**
   * Get wallet balance and flow
   * @param {Object} params
   * @param {string} params.startDate
   * @param {string} params.endDate
   */
  async getWalletFlow(params = {}) {
    try {
      const res = await this.store.query({
        endpoint: 'ViewInflowOutflowBalance',
        payload: {
          input: params
        },
        service: this.service,
        storeKey: 'transactionHistory'
      })
      return res
    } catch (error) {
      throw error
    }
  }

  /**
   * Download wallet receipt
   * @param {Object} data
   * @param {string} data.id
   * @param {string} data.type
   */
  async  downloadWalletReceipt( data) {
    try {
      let res = await this.store.query({
        endpoint: "DownloadWalletReport",
        payload: {
          input: {
            id: data.id,
            type: data.type,
          },
        },
        service: this.service,
        // storeKey: "billReceipt",
      });
      if (res.success) {
        downloadBase64(res.data.base64, res.data.fileName);
        return {success: true, message: res.message}
      } else {
        return {success: false, message: res.message}
      }
      // console.log(receiptOfBill.value, "TEMP");
    } catch (e) {
      console.log(e);
    }
  }

  async downloadWalletReport(args){
    try {
      let res = await this.store.query({
        endpoint: "SendWalletReport",
        payload: {
          input: args,
        },
        service: this.service,
      });
      if (res.success) {
        downloadBase64(res.data.b64File, `Wallet report for ${args.startDate} to ${args.endDate}.${args.csv?'xlsx':'pdf'}`);
        return {success: true, message: res.message}
      } else {
        return {success: false, message: res.message}
      }
      // console.log(receiptOfBill.value, "TEMP");
    } catch (e) {
      console.log(e);

  }
}

  async fetchWalletBalance () {
    const id = "";
   
    try {
      let res = await this.store.query({
        endpoint: "ViewWalletBalance",
        payload: {
          input: {
            companyId: id,
          },
        },
        service: this.service,
        storeKey: "walletBalance",
      });
  
      return res;
    } catch (err) {
      console.log(err);
    } 
  };

  /**
   * Fund wallet via bank transfer
   * @param {Object} data
   * @param {number} data.amount
   */
  async fundWalletWithTransfer(data) {
    try {
      const res = await this.store.mutate({
        endpoint: 'InitiateWalletFunding',
        payload: {
          input: data
        },
        service: this.service
      })
      return res
    } catch (error) {
      throw error
    }
  }

  /**
   * Fund wallet via Paystack
   * @param {Object} data
   * @param {number} data.amount
   * @param {string} data.email
   */
  async initPaystack(args) {
    args.amount = Number(args.amount);
    args.email = this.companyAdmin.companyAdmin.email
  
    try {
      let res = await this.store.mutate({
        endpoint: "PaystackPaymentInit",
        data: { input: args },
        service: this.service,
      });
  
      if (res.authorizationUrl.length) {
        this.link = res.authorizationUrl;
        await this.verifyPaystack(res.reference);
      }
    } catch (e) {
      
      console.log(e);
    }
  };

  /**
   * Verify Paystack payment
   * @param {string} paymentReference
   */
  async verifyPaystack(paymentReference) {
    try {
      const res = await this.store.query({
        endpoint: "VerifyPaystackPayment",
        service: this.service,
        payload: { input: { paymentReference } },
        storeKey: "payStackResponse",
      });
      
    } catch (e) {
      console.log(e);
    }
  }
  /**
   * Get transaction history
   * @param {Object} params
   * @param {number} params.page
   * @param {number} params.limit
   */
  async getTransactionHistory(params = {}) {
    try {
      const res = await this.store.query({
        endpoint: 'ViewTransactionHistory',
        payload: {
          input: params
        },
        service: this.service,
        storeKey: 'transactionHistory'
      })
      return res
    } catch (error) {
      throw error
    }
  }

  /**
   * Get company bank accounts
   */
  async queryCompanyAccountDetails() {
    try {
      await this.store.query({
        endpoint: "ViewCompanyVirtualAccount",
        service: "AUTH",
        storeKey: "companyAccountDetails",
      });
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * Add bank account
   * @param {Object} data
   * @param {string} data.accountNumber
   * @param {string} data.bankCode
   * @param {string} data.accountName
   */
  async addBankAccount(data) {
    try {
      const res = await this.store.mutate({
        endpoint: 'AddBankAccount',
        payload: {
          input: data
        },
        service: this.service
      })
      return res
    } catch (error) {
      throw error
    }
  }

  /**
   * Initiate withdrawal
   * @param {Object} data
   * @param {string} data.accountId
   * @param {number} data.amount
   * @param {string} data.pin
   */
  async withdrawToBankAccount(data) {
    try {
      const res = await this.store.mutate({
        endpoint: 'InitiateWithdrawal',
        payload: {
          input: data
        },
        service: this.service
      })
      return res
    } catch (error) {
      throw error
    }
  }

  /**
   * Generate wallet report
   * @param {Object} params
   * @param {string} params.startDate
   * @param {string} params.endDate
   * @param {string} params.type
   */
  async generateWalletReport(params) {
    try {
      const res = await this.store.query({
        endpoint: 'GenerateWalletReport',
        payload: {
          input: params
        },
        service: this.service,
        storeKey: 'walletReport'
      })
      return res
    } catch (error) {
      throw error
    }
  }

  /**
   * Get transaction receipt
   * @param {string} reference
   */
  async getTransactionReceipt(reference) {
    try {
      const res = await this.store.query({
        endpoint: 'ViewTransactionReceipt',
        payload: {
          input: { reference }
        },
        service: this.service,
        storeKey: 'transactionReceipt'
      })
      return res
    } catch (error) {
      throw error
    }
  }



  /**
   * Initiate bulk transfer
   * @param {Object} data
   * @param {Object} data.payload
   * @param {string} data.pin
   * @param {string} data.type
   */

  async  initiateTransfer(data) {
    let {pin, type} = data
    let payload 

    if(type === 'bulk'){

    payload = data?.payload.map((d) => {
        return {
          accountName: d.accountName,
          bankCode: d.bankCode,
          accountNumber: d.accountNumber,
          amount: Number(d.amount),
          narration: d.narration,
          options: {
            beneficiary: d.options.beneficiary,
            type: d.options.type,
            recurring: d.options.recurring,
            frequency: d.options.frequency,
          },
        };
      });
    }else{
        payload = {accountName: data?.payload?.accountName,
            bankCode: data?.payload?.bankCode,
            accountNumber: data?.payload?.accountNumber,
            amount: Number(data?.payload?.amount),
            narration: data?.payload?.narration,
            options: {
              beneficiary: data?.payload?.beneficiary,
              type: data?.payload?.type,
              recurring: data?.payload?.recurring,
              frequency: data?.payload?.frequency,
            },}
    }
    let endpoint = type === 'single' ? 'SendPayment' : 'SendPaymentBulk'
    try {
  
      let res = await this.store.mutate({
        endpoint,
        data: {
          input: payload,
          pin,
        },
        service: this.service,
      });
      if (res && res.data && res.data.failed && res.data.failed.length) {
      return {success: false, message: res.data.failed}
      }
      if (res && res.success) {
        return {success: true, message: res.message}
      } else if (res && !res.success) {
       return {success: false, message: res.message}
      }
    } catch (e) {
      
      console.log(e);
    } 
  }
 
  /**
   * Verify bank account
   * @param {Object} data
   */
  async verifyAccountName(args) {
    let endpointData = {
      accountNumber: String(args.accountNumber),
      bankCode: args.bankCode,
    };
    try {
      let res = await this.store.mutate({
        endpoint: "VerifyAccountDetails",
        data: { input: endpointData },
        service: "EMP",
      });
      if (res.success === true) {
        // args.accountName = res.data.data.account_name;
        return res.data.data.account_name;
      }
    } catch (e) {
      console.error(e.message);
    } 
  }

  /**
   * Validate transaction PIN
   * @param {string} pin
   */
  async validateTransactionPin(pin) {
    try {
      const res = await this.store.query({
        endpoint: 'ValidateTransactionPin',
        payload: {
          input: { pin }
        },
        service: this.service,
        storeKey: 'pinValidation'
      })
      return res
    } catch (error) {
      throw error
    }
  }

  /**
   * Reset transaction PIN
   * @param {Object} data
   */
  async resetTransactionPin(data) {
    try {
      const res = await this.store.mutate({
        endpoint: 'ResetTransactionPin',
        payload: {
          input: data
        },
        service: this.service
      })
      return res
    } catch (error) {
      throw error
    }
  }
}

export const walletService = new WalletService() 